import { render, staticRenderFns } from "./SumCalculator.vue?vue&type=template&id=4db69ebe&"
import script from "./SumCalculator.vue?vue&type=script&lang=js&"
export * from "./SumCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports